<template>
  <div class="con-wrap">
    <p class="box-title">加油记录</p>
    <div class="data-wrap">
      <div class="query-box">
        <el-form size="mini" :inline="true">
          <el-form-item>
            <el-date-picker v-model="queryDate" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form>
      </div>
      <div class="data-box">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="mini" stripe
          height="560px">
          <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
          <el-table-column label="使用人" min-width="90" prop="ownerName"></el-table-column>
          <el-table-column prop="startTime" width="180px" label="起始点时间"></el-table-column>
          <el-table-column prop="startOil" label="起始点油量(升)" min-width="120"></el-table-column>
          <el-table-column prop="endTime" width="180px" label="结束点时间"></el-table-column>
          <el-table-column prop="endOil" label="结束点油量(升)" min-width="120"></el-table-column>
          <el-table-column prop="addOil" label="本次加油量(升)" min-width="120"></el-table-column>
          <el-table-column prop="type" label="加油操作" min-width="160px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type == 2" style="color: #ff0000">{{
                addOilResult(scope.row)
              }}</span>
              <span v-else-if="scope.row.type == 1 && scope.row.station == 2">未在加油站加油</span>
              <span v-else>正常加油</span>
            </template>
          </el-table-column>
          <el-table-column prop="vin" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click.stop="location(scope.row)">
                加油位置
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-size="limit" layout="total, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </div>
    <!-- 加油前后定位对比-->
    <el-dialog title="加油位置对比" :visible.sync="locationVisible" class="map-dialog">
      <div id="open-map"></div>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "RefuelingRecord",
  props: {
    vin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      locationVisible: false,
      queryDate: "",
      startMarker: "",
      endMarker: "",
      markers: [],
      content: [],
      tableData: [],
      startPosition: [],
      endPosition: [],
      geocoder: {},
      startInfoWindow: "",
      endInfoWindow: "",
      scale: null,
      //防止每次数据改变重置定位地图
      opnMap: null,
      onceFlag: true,
      clickFlag: false,
      openFlag: false,
      limit: 10,
      currentPage: 1,
      total: 0,
    };
  },
  updated() {
    if (this.onceFlag) {
      this.opnMap = new AMap.Map("open-map", {
        // center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 20,
      });
      AMap.plugin(["AMap.Geocoder"], () => {
        this.geocoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        });
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.opnMap.addControl(this.scale);
      });
    }
    if (this.clickFlag) {
      this.onceFlag = false;
    }
  },
  mounted() {
    // this.init()
    this.getRefuelingData();
  },
  methods: {
    addOilResult(row) {
      if (row.flameout == 2 && row.station == 2) {
        return "未熄火加油，未在加油站加油";
      }
      if (row.flameout == 2) {
        return "未熄火加油";
      }
      if (row.station == 2) {
        return "未在加油站加油";
      }
    },
    query() {
      this.getRefuelingData();
    },
    reset() {
      this.$resetForm(this, "queryDate");
      this.getRefuelingData();
    },
    // 查询加油前后定位
    location(data) {
      let _this = this;
      _this.locationVisible = true;
      _this.startPosition = [data.startLongitude, data.startLatitude];
      //清理覆盖物
      if (_this.startMarker) {
        _this.opnMap.remove(_this.startMarker);
      }
      _this.startMarker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
        position: _this.startPosition,
      });
      _this.getAddr(
        _this.startPosition,
        data.type,
        data.flameout,
        data.station
      );
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.opnMap.setCenter(_this.startPosition);
        _this.opnMap.add(_this.startMarker);
        AMap.event.addListener(_this.startMarker, "click", function () {
          _this.opnMap.clearInfoWindow();
          _this.startInfoWindow.open(
            _this.opnMap,
            _this.startMarker.getPosition()
          );
        });
      });
    },
    getAddr(position, type, flameout, station) {
      // 确保 geocoder 已初始化
      if (!this.geocoder) {
        console.error("Geocoder 未初始化，请检查插件加载");
        return;
      }
      let _this = this;
      _this.geocoder.getAddress(position, function (status, result) {
        if (status === "complete" && result.regeocode) {
          _this.content = [];
          if (type == 2) {
            let flameoutStr = flameout == 2 ? "未熄火加油" : " ";
            let stationStr = station == 2 ? "未在加油站加油" : " ";
            _this.content.push(
              "<p><span style='margin-right:6px'>加油位置: </span>" +
              result.regeocode.formattedAddress +
              "</p><p style='color:#f00'>" +
              "<span style='margin-right:6px'>" +
              flameoutStr +
              "</span><span style='margin-right:6px'>" +
              stationStr +
              "</span></p>"
            );
          } else {
            _this.content.push(
              "<p><span style='margin-right:6px'>加油位置: </span>" +
              result.regeocode.formattedAddress +
              "</p><p><span style='color:#0094FF'>正常加油</span></p>"
            );
          }
          _this.startInfoWindow = new AMap.InfoWindow({
            isCustom: true,
            content: _this.createInfoWindow(_this.content),
            offset: new AMap.Pixel(16, -45),
          });
          _this.opnMap.clearInfoWindow();
          _this.startInfoWindow.open(
            _this.opnMap,
            _this.startMarker.getPosition()
          );
        } else {
          _this.$message.warning("根据经纬度查询地址失败");
        }
      });
    },
    createInfoWindow() {
      let _this = this;
      var info = document.createElement("div");
      info.style.background = "#fff";
      info.style.height = "99px";
      info.style.border = "1px solid #ccc";
      info.style.borderRadius = "4px";
      //顶部内容
      var top = document.createElement("div");
      top.style.height = "26px";
      top.style.position = "relative";
      info.className = "realtimeLocation";
      var closeX = document.createElement("img");
      closeX.style.position = "absolute";
      closeX.style.top = "10px";
      closeX.style.right = "10px";
      closeX.style.cursor = "pointer";
      closeX.src = "https://webapi.amap.com/images/close2.gif";
      closeX.addEventListener("click", () => {
        _this.opnMap.clearInfoWindow();
      });
      top.appendChild(closeX);
      info.appendChild(top);
      // 定义中部内容
      var middle = document.createElement("div");
      middle.style.backgroundColor = "white";
      middle.style.padding = "0 20px";
      middle.style.color = "#333";
      middle.innerHTML = this.content;
      info.appendChild(middle);
      //底部内容
      var bottom = document.createElement("div");
      bottom.style.position = "relative";
      bottom.style.width = "30px";
      bottom.style.top = "16px";
      bottom.style.left = "146px";
      var sharp = document.createElement("img");
      sharp.src = "https://webapi.amap.com/images/sharp.png";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },
    async getRefuelingData() {
      let _this = this;
      let obj = {
        vin: _this.vin,
        date: _this.queryDate,
        limit: _this.limit,
        page: _this.currentPage,
      };
      let { data: res } = await _this.$axios.get("/api/vehicle/details/oils", {
        params: obj,
      });
      if (res.code == 1) {
        // if (res.data && res.data.length > 0) {
        //   // _this.tableData = res.data.records;
        // }
        _this.tableData = res.data.records;
        _this.total = res.data.total;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getRefuelingData();
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: 100%;
  margin: 0;
  background-color: #fff;
}

.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}

.data-wrap {
  width: 100%;
  height: calc(100% - 31px);
  padding: 20px;
  box-sizing: border-box;
}

.data-box {
  width: 100%;
  height: calc(100% - 84px);
}

#open-map {
  width: 100%;
  height: 580px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}
</style>
